import {
  AlertProps as MantineAlertProps,
  Alert as MantineAlert,
} from '@mantine/core';

export type AlertProps = MantineAlertProps;

export const Alert = MantineAlert;

Alert.displayName = 'Alert';
